<template>
  <div class="login-page">
    <div class="container main-container animate__animated animate__fadeIn">
      <div class="row align-items-center h-100">
        <div class="col-md-6 pt-5 pt-md-0">
          <div class="d-flex align-items-center">
            <img
              src="@/core/assets/images/layout/logo-admin.png"
              alt="TRAVELCAB"
              class="logo"
            />
          </div>

          <p class="description mt-3">Accede para descubrir la magia</p>

          <FormLogin @reset="showFormReset = true" />
        </div>

        <div class="col-md-6 pb-5 pb-md-0">
          <div class="carousel text-center pb-5 pb-md-0">
            <swiper class="swiper relative" :options="swiperOptions">
              <swiper-slide class="d-flex flex-column justify-content-center align-items-center">
                <img
                  src="@/core/assets/images/login/login-image-1.png"
                  alt="TRAVELCAB"
                  class="img-fluid"
                />

                <div class="carousel-content text-center">
                  <p class="carousel-title mb-1">
                    Gestiona tus reservas con eficiencia y confianza
                  </p>
                  <p class="carousel-description my-0">
                    Administra tus traslados, clientes y conductores desde un solo lugar. Nuestro sistema unifica la operación para que tu equipo gane tiempo, seguridad y control total.
                  </p>
                </div>
              </swiper-slide>

              <!-- <div class="swiper-pagination" slot="pagination"></div> -->
            </swiper>
          </div>
        </div>
      </div>
    </div>

    <RecoverPasswordModal @hide="showFormReset = false" :show="showFormReset"/>
  </div>
</template>

<script>
// import { SecurityService } from "@/core/services";
// import { ErrorUtils, SSOUtils } from "wize-admin";

import FormLogin from "../Components/FormLogin.vue";
import RecoverPasswordModal from '../Components/RecoverPasswordModal.vue';

export default {
  name: "LoginPage",
  data() {
    return {
      error: false,
      errorMsg: null,
      swiperOptions: {
        loop: false,
        // autoplay: {
        //   delay: 4000,
        //   disableOnInteraction: false,
        // },
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        // },
      },
      showFormReset: false
    };
  },
  components: {
    FormLogin,
    RecoverPasswordModal
  },
  methods: {
  },
};
</script>

<style lang="stylus">
@import '../Styles/login-page';
</style>
